"use strict";var e=require("../precomputed/Instamart/InstamartTheme.js"),t=require("../precomputed/Instamart/InstamartThemeDesktop.js");exports.InstamartTheme=e.InstamartTheme,exports.InstamartThemeDesktop=t.InstamartThemeDesktop;
//# sourceMappingURL=index.js.map
